// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2jNNg","content":"ManualTimeModal_content__cF19M"};